// removed by extract-text-webpack-plugin
module.exports = {"empty-text":"SortableTable__empty-text___3vtf9","sf-table":"SortableTable__sf-table___1DReN"};